import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, styled as muiStyled, Paper } from '@mui/material';
import { motion } from 'framer-motion';

export const InfoBar = muiStyled(Paper)({
  background: '#cbe0f6',
  borderRadius: '8px',
  width: '100%',
  padding: 'var(--spacing-md)',
  marginBottom: 'var(--spacing-md)',
  boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.05)',
});

export const Chevron = muiStyled(ChevronRightIcon, {
  shouldForwardProp: prop => prop !== '$open',
})<{ $open: boolean }>(({ $open }) => ({
  transform: `rotate(${$open ? 90 : 0}deg)`,
  transition: 'transform 0.3s ease',
}));

export const Section = muiStyled(Box)({
  marginTop: 'var(--spacing-md)',
  width: '100%',
  backgroundColor: '#fff8eb',
  border: '1px solid #e0e0e0',
  padding: '10px 30px 10px',
  borderRadius: '7px',
  marginBottom: 'var(--spacing-md)',
});

export const SectionTitle = muiStyled('h3')({
  fontSize: '1.25rem',
  fontWeight: 600,
  marginTop: 'var(--spacing-xs)',
  color: '#222',
});

export const SectionSubtext = muiStyled('p')({
  fontSize: '0.95rem',
  marginTop: 'var(--spacing-xs)',
  marginBottom: 'var(--spacing-xs)',
  color: '#666',
});

export const TextContainer = muiStyled(Box)({
  'display': 'flex',
  'flexDirection': 'column',
  'fontSize': '0.9rem',
  '& ul li': {
    marginLeft: '-15px',
  },
});

export const RequestsHeader = muiStyled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
});

export const CardList = muiStyled(motion.div)({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  marginTop: '16px',
});

export const Title = muiStyled('h2')({
  margin: 0,
  fontSize: '1.5rem',
  fontWeight: 600,
  color: '#4a3f33',
});

export const Subtext = muiStyled('p')({
  margin: '8px 0 0',
  fontSize: '1rem',
  color: '#666',
  marginBottom: 'var(--spacing-xs)',
});
